import React, { useState } from 'react';
import { resetPassword } from '../apiCallsHelper/authapicalls';
import { useParams, Link } from 'react-router-dom';
import todoLogo from "../images/TodoMate-logo.png"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from '../utils/LoadingOverlay';



const PasswordReset = () => {

    const { resetToken } = useParams();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);




    const handleSubmit = () => {
        setIsLoading(true);
        resetPassword(resetToken, password, confirmPassword).then(data => {
            if (data.error) {
                toast.error(data.error);
                setIsLoading(false);
                setMessage(data.error);
            }
            else {
                toast.success(data.message);
                setIsLoading(false);
                setMessage(data.message)
                setPassword("");
                setConfirmPassword("");
            }
        })
    }




    return (
        <>
            <Link className='mt-4 flex justify-center' to="/">
                <img src={todoLogo} className='w-[80px] h-[80px]' alt="todo logo" />
            </Link>
            {isLoading && <LoadingOverlay />}
            <div className='mt-[-40px]  w-[250px] h-[500px]   xs:w-[340px] xs:h-[450px]   sm:w-[400px] sm:h-[450px]  md:w-[420px] md:h-[450px]  smLaptop:w-[440px] smLaptop:h-[450px]   lg:w-[470px] lg:h-[470px]   xl:w-[470px] xl:h-[470px]    container  mx-auto border-2 border-gray-300 rounded-md'>
                <div className='w-[220px] xs:w-[300px] sm:w-[340px]  md:w-[340px] smLaptop:w-[340px] lg:w-[380px] xl:w-[380px] mx-auto mt-4 '>
                    <div className='text-blue-500  mt-10 h-4 text-center'>
                        {message ? message : ""}
                    </div>
                    <div className='text-3xl mt-6 text-center font-bold text-[#183e70]'>
                        Recover Password
                    </div>
                    <div className='mt-6'>
                        <div className='mt-4'>
                            <label htmlFor="recoveryPassword" className='font-semibold text-[#183e70]'>Password</label>
                            <input value={password} onChange={(event) => setPassword(event.target.value)} type="password" id="recoveryPassword" className="bg-gray-50 text-black  pl-2 pr-2 py-2 border border-gray-300  focus:outline-blue-300  rounded w-full" />
                        </div>
                        <div className='mt-4'>
                            <label htmlFor="recoveryConfirmPassword" className='mt-2 font-semibold text-[#183e70]'>Confirm password</label>
                            <input value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} type="password" id="recoveryConfirmPassword" className="bg-gray-50 text-black  pl-2 pr-2 py-2 border border-gray-300  focus:outline-blue-300  rounded w-full" />
                        </div>
                    </div>
                    <button onClick={handleSubmit} className='bg-[#8ab5ff] text-white mt-10 py-2 w-full rounded-md hover:bg-[#7fa3e3]'>Submit</button>
                    <Link className='mt-4 text-xs text-blue-500 cursor-pointer float-right' to="/signin">
                        Would you like to login?
                    </Link>
                </div>
            </div>
        </>
    )
}



export default PasswordReset